/**
 * 计算字符串的哈希值，并映射到指定范围中的一个索引
 * @param {string} str - 输入字符串
 * @param {number} range - 映射范围，默认为 4
 * @returns {number} 映射后的索引（0 到 range-1）
 */
export function hashToIndex(str: string, range: number = 4): number {
  // 步骤 1：计算字符串的哈希值（自定义简单哈希）
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    const charCode = str.charCodeAt(i);
    // 简单哈希算法：累加字符编码并混合运算（减少碰撞）
    hash = (hash << 5) - hash + charCode;
    hash = hash & hash; // 转换为 32 位整数
  }

  // 步骤 2：将哈希值转为非负整数（避免负数取模问题）
  const positiveHash = Math.abs(hash);

  // 步骤 3：取模，映射到 0 到 range-1
  const result = positiveHash % range;

  return result;
}

/**
 * 格式化美元金额，自动添加单位并在截断小数时显示+号
 * @param {number} amount - 美元金额
 * @returns {string} 格式化后的金额字符串
 */
export function formatDollarAmount(amount: number): string {
  if (isNaN(amount)) {
    return '$0';
  }

  const units = ['K', 'M', 'B', 'T', 'Q'];
  let currentAmount = amount;
  let unitIndex = -1;

  // 处理大于等于1000的金额
  if (currentAmount >= 1000) {
    while (currentAmount >= 1000 && unitIndex < units.length - 1) {
      currentAmount /= 1000;
      unitIndex++;
    }

    const isInteger = Number.isInteger(currentAmount);
    const integerPart = Math.trunc(currentAmount);
    const unit = unitIndex >= 0 ? units[unitIndex] : '';
    const plusSign = isInteger ? '' : '+';

    return `$${integerPart}${unit}${plusSign}`;
  }

  // 处理小于1000的金额
  const isInteger = Number.isInteger(currentAmount);
  const integerPart = Math.trunc(currentAmount);
  const plusSign = isInteger ? '' : '+';

  return `$${integerPart}${plusSign}`;
}
